import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Button, Table } from "antd";
import { BarChartOutlined, FileExcelOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

import * as xlsx from "xlsx";

const { Title } = Typography;

const cardStyle = {
  height: 450,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_3 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [data7_3_10, _data7_3_10] = useState();
  const [data7_3_11, _data7_3_11] = useState();

  const [dataBar7_3_1, _dataBar7_3_1] = useState();
  const [dataBar7_3_2, _dataBar7_3_2] = useState();
  const [dataBar7_3_3, _dataBar7_3_3] = useState();
  const [dataBar7_3_4, _dataBar7_3_4] = useState();

  useEffect(() => {
    Find_barData("bar7_3_1");
    Find_barData("bar7_3_2");
    Find_barData("bar7_3_3");
    // Find_barData("bar7_3_4");

    Find_Data("data7_3_10");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_3", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_3_1") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_2") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_3") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_4") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_3_1") {
          _dataBar7_3_1(Tb1);
        } else if (order == "bar7_3_2") {
          _dataBar7_3_2(Tb1);
        } else if (order == "bar7_3_3") {
          _dataBar7_3_3(Tb1);
        } else if (order == "bar7_3_4") {
          _dataBar7_3_4(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_Data = order => {
    axios
      .post(xURL + "db_data_db7_3", {
        order: order
      })
      .then(result => {
        //console.log(result.data);
        if (order == "data7_3_10") {
          _data7_3_10(result.data);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const columns7_3_5 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_5 = [
    {
      key: "1",
      c1: "จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS",
      c2: "148"
    },
    {
      key: "2",
      c1: "อาจารย์",
      c2: "7"
    },
    {
      key: "3",
      c1: "อัตราส่วน",
      c2: "21.14"
    }
  ];

  const dataEx7_3_5 = [
    {
      c1: "จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS",
      c2: "148"
    },
    {
      c1: "อาจารย์",
      c2: "7"
    },
    {
      c1: "อัตราส่วน",
      c2: "21.14"
    }
  ];

  const columns7_3_6 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_6 = [
    {
      key: "1",
      c1: "จำนวนอาจารย์ทั้งหมด",
      c2: "7"
    },
    {
      key: "2",
      c1: "จำนวนอาจารย์ที่มีตำแหน่งวิชาการ",
      c2: "6"
    },
    {
      key: "3",
      c1: "จำนวนร้อยละ อาจารย์มีตำแหน่งวิชาการ",
      c2: "85.714286"
    }
  ];

  const dataEx7_3_6 = [
    {
      c1: "จำนวนอาจารย์ทั้งหมด",
      c2: "7"
    },
    {
      c1: "จำนวนอาจารย์ที่มีตำแหน่งวิชาการ",
      c2: "6"
    },
    {
      c1: "จำนวนร้อยละ อาจารย์มีตำแหน่งวิชาการ",
      c2: "85.714286"
    }
  ];

  const columns7_3_8 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2564",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "ปี 2565",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "ปี 2566",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "ปี 2567",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_3_8 = [
    {
      key: "1",
      c1: "สายสนับสนุนการวิจัย",
      c2: "92",
      c3: "92",
      c4: "92",
      c5: "90",
      c6: "85.2"
    },
    {
      key: "2",
      c1: "สายปฏิบัติการทั่วไป",
      c2: "92",
      c3: "89",
      c4: "89",
      c5: "91",
      c6: "95.3"
    }
  ];

  const dataEx7_3_8 = [
    {
      c1: "สายสนับสนุนการวิจัย",
      c2: "92",
      c3: "92",
      c4: "92",
      c5: "90",
      c6: "85.2"
    },
    {
      c1: "สายปฏิบัติการทั่วไป",
      c2: "92",
      c3: "89",
      c4: "89",
      c5: "91",
      c6: "95.3"
    }
  ];

  const columns7_3_9 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_9 = [
    {
      key: "1",
      c1: "CMCB",
      c2: "85.62"
    },
    {
      key: "2",
      c1: "IDSU",
      c2: "93.2"
    },
    {
      key: "3",
      c1: "NINE",
      c2: "95.5"
    },
    {
      key: "4",
      c1: "ADMIN",
      c2: "90.8"
    },
    {
      key: "5",
      c1: "SHSR",
      c2: "92.1"
    },
    {
      key: "6",
      c1: "RSO",
      c2: "88.8"
    }
  ];

  const dataEx7_3_9 = [
    {
      c1: "CMCB",
      c2: "85.62"
    },
    {
      c1: "IDSU",
      c2: "93.2"
    },
    {
      c1: "NINE",
      c2: "95.5"
    },
    {
      c1: "ADMIN",
      c2: "90.8"
    },
    {
      c1: "SHSR",
      c2: "92.1"
    },
    {
      c1: "RSO",
      c2: "88.8"
    }
  ];

  const columns7_3_10 = [
    {
      title: "",
      dataIndex: "metric",
      key: "metric",
      align: "left"
    },
    {
      title: "",
      dataIndex: "metric2",
      key: "metric2",
      align: "center"
    },
    {
      title: "64",
      dataIndex: "y64",
      key: "y64",
      align: "center"
    },
    {
      title: "65",
      dataIndex: "y65",
      key: "y65",
      align: "center"
    },
    {
      title: "66",
      dataIndex: "y66",
      key: "y66",
      align: "center"
    },
    {
      title: "67",
      dataIndex: "y67",
      key: "y67",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "y68",
      key: "y68",
      align: "center"
    }
  ];

  const columns7_3_11 = [
    {
      title: "",
      dataIndex: "metric",
      key: "metric",
      align: "left"
    },
    {
      title: "64",
      dataIndex: "y64",
      key: "y64",
      align: "center"
    },
    {
      title: "65",
      dataIndex: "y65",
      key: "y65",
      align: "center"
    },
    {
      title: "66",
      dataIndex: "y66",
      key: "y66",
      align: "center"
    },
    {
      title: "67",
      dataIndex: "y67",
      key: "y67",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "y68",
      key: "y68",
      align: "center"
    }
  ];

  const highlightRows = [
    "จำนวน อจ. ต่อ จำนวน นศ.",
    "จำนวน อจ. + นวจ. ต่อ จำนวน นศ."
  ];

  const columns7_3_12 = [
    {
      title: "ปีการศึกษา",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "2565",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "รวม 2565-2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_3_12 = [
    {
      key: "1",
      c1: "จำนวน นศ.",
      c2: "20",
      c3: "15",
      c4: "15",
      c5: "20",
      c6: "70"
    },
    {
      key: "2",
      c1: "จำนวน อจ.",
      c2: "7",
      c3: "7",
      c4: "7",
      c5: "7",
      c6: "7"
    },
    {
      key: "3",
      c1: "จำนวน อจ. ต่อ จำนวน นศ.",
      c2: "1:2.85",
      c3: "1:2.14",
      c4: "1:2.14",
      c5: "1:2.85",
      c6: "1:1.10"
    },
    {
      key: "4",
      c1: "จำนวน อจ. + นวจ.",
      c2: "23",
      c3: "23",
      c4: "23",
      c5: "23",
      c6: "23"
    },
    {
      key: "5",
      c1: "จำนวน อจ. + นวจ. ต่อ จำนวน นศ.",
      c2: "1:0.87",
      c3: "1:0.65",
      c4: "1:0.65",
      c5: "1:0.87",
      c6: "1:3.04"
    }
  ];

  const dataEx7_3_12 = [
    {
      c1: "จำนวน นศ.",
      c2: "20",
      c3: "15",
      c4: "15",
      c5: "20",
      c6: "70"
    },
    {
      c1: "จำนวน อจ.",
      c2: "7",
      c3: "7",
      c4: "7",
      c5: "7",
      c6: "7"
    },
    {
      c1: "จำนวน อจ. ต่อ จำนวน นศ.",
      c2: "1:2.85",
      c3: "1:2.14",
      c4: "1:2.14",
      c5: "1:2.85",
      c6: "1:1.10"
    },
    {
      c1: "จำนวน อจ. + นวจ.",
      c2: "23",
      c3: "23",
      c4: "23",
      c5: "23",
      c6: "23"
    },
    {
      c1: "จำนวน อจ. + นวจ. ต่อ จำนวน นศ.",
      c2: "1:0.87",
      c3: "1:0.65",
      c4: "1:0.65",
      c5: "1:0.87",
      c6: "1:3.04"
    }
  ];

  const columns7_3_13 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปี 2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_13 = [
    {
      key: "1",
      c1: "กลุ่มสนับสนุนการวิจัย",
      c2: "136"
    },
    {
      key: "2",
      c1: "กลุ่มปฏิบัติการทั่วไป",
      c2: "51"
    },
    {
      key: "3",
      c1: "กลุ่มวิชาการ",
      c2: "22"
    },
    {
      key: "4",
      c1: "ข้อมูล ณ. วันที่ 30 มิ.ย. 68",
      c2: "209"
    }
  ];

  const dataEx7_3_13 = [
    {
      c1: "กลุ่มสนับสนุนการวิจัย",
      c2: "136"
    },
    {
      c1: "กลุ่มปฏิบัติการทั่วไป",
      c2: "51"
    },
    {
      c1: "กลุ่มวิชาการ",
      c2: "22"
    },
    {
      c1: "ข้อมูล ณ. วันที่ 30 มิ.ย. 68",
      c2: "209"
    }
  ];

  const columns7_3_14 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2565",
      key: "c2",
      align: "center",
      children: [
        {
          title: "จำนวนที่ขอ : จำนวนที่ได้",
          dataIndex: "c2_1",
          key: "c2_1",
          align: "center"
        },
        {
          title: "ร้อยละ",
          dataIndex: "c2_2",
          key: "c2_2",
          align: "center"
        }
      ]
    },
    {
      title: "2566",
      key: "c3",
      align: "center",
      children: [
        {
          title: "จำนวนที่ขอ : จำนวนที่ได้",
          dataIndex: "c3_1",
          key: "c3_1",
          align: "center"
        },
        {
          title: "ร้อยละ",
          dataIndex: "c3_2",
          key: "c3_2",
          align: "center"
        }
      ]
    },
    {
      title: "2567",
      key: "c4",
      align: "center",
      children: [
        {
          title: "จำนวนที่ขอ : จำนวนที่ได้",
          dataIndex: "c4_1",
          key: "c4_1",
          align: "center"
        },
        {
          title: "ร้อยละ",
          dataIndex: "c4_2",
          key: "c4_2",
          align: "center"
        }
      ]
    },
    {
      title: "2568",
      key: "c5",
      align: "center",
      children: [
        {
          title: "จำนวนที่ขอ : จำนวนที่ได้",
          dataIndex: "c5_1",
          key: "c5_1",
          align: "center"
        },
        {
          title: "ร้อยละ",
          dataIndex: "c5_2",
          key: "c5_2",
          align: "center"
        }
      ]
    }
  ];

  const data7_3_14 = [
    {
      key: "1",
      c1: "อาจารย์",
      c2_1: "2:0",
      c2_2: "0",
      c3_1: "2:2",
      c3_2: "100",
      c4_1: "2:0",
      c4_2: "0",
      c5_1: "2:0",
      c5_2: "0"
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2_1: "5:1",
      c2_2: "20",
      c3_1: "5:0",
      c3_2: "0",
      c4_1: "5:0",
      c4_2: "0",
      c5_1: "5:0",
      c5_2: "0"
    },
    {
      key: "3",
      c1: "สนับสนุนงานวิจัย",
      c2_1: "3:2",
      c2_2: "66.66",
      c3_1: "2:0",
      c3_2: "0",
      c4_1: "2:2",
      c4_2: "100",
      c5_1: "1:1",
      c5_2: "100"
    },
    {
      key: "4",
      c1: "ปฏิบัติงานทั่วไป",
      c2_1: "3:1",
      c2_2: "33.33",
      c3_1: "1:1",
      c3_2: "100",
      c4_1: "2:0",
      c4_2: "0",
      c5_1: "1:0",
      c5_2: "0"
    }
  ];

  const dataEx7_3_14 = [
    {
      c1: "อาจารย์",
      c2_1: "2:0",
      c2_2: "0",
      c3_1: "2:2",
      c3_2: "100",
      c4_1: "2:0",
      c4_2: "0",
      c5_1: "2:0",
      c5_2: "0"
    },
    {
      c1: "นักวิจัย",
      c2_1: "5:1",
      c2_2: "20",
      c3_1: "5:0",
      c3_2: "0",
      c4_1: "5:0",
      c4_2: "0",
      c5_1: "5:0",
      c5_2: "0"
    },
    {
      c1: "สนับสนุนงานวิจัย",
      c2_1: "3:2",
      c2_2: "66.66",
      c3_1: "2:0",
      c3_2: "0",
      c4_1: "2:2",
      c4_2: "100",
      c5_1: "1:1",
      c5_2: "100"
    },
    {
      c1: "ปฏิบัติงานทั่วไป",
      c2_1: "3:1",
      c2_2: "33.33",
      c3_1: "1:1",
      c3_2: "100",
      c4_1: "2:0",
      c4_2: "0",
      c5_1: "1:0",
      c5_2: "0"
    }
  ];

  const columns7_3_15 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => {
        const isHeader = text === "สายวิชาการ" || text === "สายสนับสนุน";

        return {
          children: (
            <div
              style={{
                fontWeight: isHeader ? "bold" : "normal",
                textAlign: "left"
              }}
            >
              {text}
            </div>
          ),
          props: {
            colSpan: isHeader ? 7 : 1 // มีทั้งหมด 7 columns
          }
        };
      }
    },
    {
      title: "ปี 2564",
      dataIndex: "c2",
      key: "c2",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    },
    {
      title: "ปี 2565",
      dataIndex: "c3",
      key: "c3",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    },
    {
      title: "ปี 2566",
      dataIndex: "c4",
      key: "c4",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    },
    {
      title: "ปี 2567",
      dataIndex: "c5",
      key: "c5",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    },
    {
      title: "ปี 2568",
      dataIndex: "c6",
      key: "c6",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    },
    {
      title: "% ได้ต่อสัญญาใหม่",
      dataIndex: "c7",
      key: "c7",
      align: "center",
      render: (text, record) => {
        const isHeader =
          record.c1 === "สายวิชาการ" || record.c1 === "สายสนับสนุน";
        return {
          children: text,
          props: {
            colSpan: isHeader ? 0 : 1
          }
        };
      }
    }
  ];

  const data7_3_15 = [
    {
      key: "1",
      c1: "สายวิชาการ"
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2: "-",
      c3: "96.3",
      c4: "-",
      c5: "90.5",
      c6: "90.33",
      c7: "100"
    },
    {
      key: "3",
      c1: "อาจารย์",
      c2: "-",
      c3: "-",
      c4: "92.5",
      c5: "-",
      c6: "-",
      c7: "-"
    },
    {
      key: "4",
      c1: "สายสนับสนุน"
    },
    {
      key: "5",
      c1: "สนับสนุนการวิจัย",
      c2: "93",
      c3: "95",
      c4: "-",
      c5: "90",
      c6: "96.5",
      c7: "100"
    },
    {
      key: "6",
      c1: "ปฏิบัติการทั่วไป",
      c2: "90",
      c3: "91.5",
      c4: "92",
      c5: "92.67",
      c6: "90",
      c7: "100"
    }
  ];

  const dataEx7_3_15 = [
    {
      c1: "สายวิชาการ"
    },
    {
      c1: "นักวิจัย",
      c2: "-",
      c3: "96.3",
      c4: "-",
      c5: "90.5",
      c6: "90.33",
      c7: "100"
    },
    {
      c1: "อาจารย์",
      c2: "-",
      c3: "-",
      c4: "92.5",
      c5: "-",
      c6: "-",
      c7: "-"
    },
    {
      c1: "สายสนับสนุน"
    },
    {
      c1: "สนับสนุนการวิจัย",
      c2: "93",
      c3: "95",
      c4: "-",
      c5: "90",
      c6: "96.5",
      c7: "100"
    },
    {
      c1: "ปฏิบัติการทั่วไป",
      c2: "90",
      c3: "91.5",
      c4: "92",
      c5: "92.67",
      c6: "90",
      c7: "100"
    }
  ];

  const columns7_3_18 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_3_18 = [
    {
      key: "1",
      c1: "อาจารย์",
      c2: "0"
    },
    {
      key: "2",
      c1: "นักวิจัย",
      c2: "0"
    },
    {
      key: "3",
      c1: "สนับสนุนการวิจัย",
      c2: "1"
    },
    {
      key: "4",
      c1: "ปฏิบัติดารทั่วไป",
      c2: "2"
    }
  ];

  const dataEx7_3_18 = [
    {
      c1: "อาจารย์",
      c2: "0"
    },
    {
      c1: "นักวิจัย",
      c2: "0"
    },
    {
      c1: "สนับสนุนการวิจัย",
      c2: "1"
    },
    {
      c1: "ปฏิบัติดารทั่วไป",
      c2: "2"
    }
  ];

  const columns7_3_22 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1"
    },
    {
      title: "2564",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2565",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_3_22 = [
    {
      key: "1",
      c1: "ร้อยละบุคลากรเข้าระบบ CMU IDP",
      c2: "N/A",
      c3: "N/A",
      c4: "23.35",
      c5: "21.51",
      c6: "N/A"
    },
    {
      key: "2",
      c1: "ผลการประเมินหัวหน้างาน",
      c2: "91.8",
      c3: "90.5",
      c4: "90.7",
      c5: "96.2",
      c6: "96"
    },
    {
      key: "3",
      c1: "ร้อยละผู้บริหารเข้า cmu PFL",
      c2: "N/A",
      c3: "N/A",
      c4: "77.7",
      c5: "ไม่มีผู้เข้าเกณฑ์",
      c6: "ไม่มีผู้เข้าเกณฑ์"
    },
    {
      key: "4",
      c1: "ผลประเมินของผู้บริหารระดับต้นและกลาง",
      c2: "93.2",
      c3: "93.5",
      c4: "94.0",
      c5: "95.3",
      c6: "87.17"
    }
  ];

  const dataEx7_3_22 = [
    {
      c1: "ร้อยละบุคลากรเข้าระบบ CMU IDP",
      c2: "N/A",
      c3: "N/A",
      c4: "23.35",
      c5: "21.51",
      c6: "N/A"
    },
    {
      c1: "ผลการประเมินหัวหน้างาน",
      c2: "91.8",
      c3: "90.5",
      c4: "90.7",
      c5: "96.2",
      c6: "96"
    },
    {
      c1: "ร้อยละผู้บริหารเข้า cmu PFL",
      c2: "N/A",
      c3: "N/A",
      c4: "77.7",
      c5: "ไม่มีผู้เข้าเกณฑ์",
      c6: "ไม่มีผู้เข้าเกณฑ์"
    },
    {
      c1: "ผลประเมินของผู้บริหารระดับต้นและกลาง",
      c2: "93.2",
      c3: "93.5",
      c4: "94.0",
      c5: "95.3",
      c6: "87.17"
    }
  ];

  const bExcelClick = xorder => {
    // console.log("Excel button clicked for order:", xorder);
    let xdata = [],
      xtabtitle = "report",
      header = [],
      header2 = [];

    if (xorder === "7_3_5") {
      xtabtitle = "7.3-5 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่ออาจารย์";

      header.push("", "2568");
    } else if (xorder === "7_3_6") {
      xtabtitle = "7.3-6 ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ";
      header.push("", "ปี 2568");
    } else if (xorder === "7_3_8") {
      xtabtitle = "7.3-8 ผลการประเมินขีดความสามารถบุคลากรสายปฏิบัติการ";
      header.push("", "ปี 2564", "ปี 2565", "ปี 2566", "ปี 2567", "ปี 2568");
    } else if (xorder === "7_3_9") {
      xtabtitle = "7.3-9 ผลการประเมินการให้บริการและสนับสนุนสายวิชาการ";
      header.push("", "2568");
    } else if (xorder === "7_3_10") {
      xtabtitle = "7.3-10 สัดส่วนจำนวนโครงการและทุนวิจัยต่อนักวิจัย";
      header.push("", "", "64", "65", "66", "67", "68");
    } else if (xorder === "7_3_12") {
      xtabtitle = "7.3-12 อัตราส่วนของ นศ. ต่อบุคลากรสายวิชาการ";
      header.push(
        "ปีการศึกษา",
        "2565",
        "2566",
        "2567",
        "2568",
        "รวม 2565-2568"
      );
    } else if (xorder === "7_3_13") {
      xtabtitle = "7.3-13 จำนวนและอัตรส่วนของบุคลากรสายสับสนุน และสายวิชาการ";
      header.push("", "2568");
    } else if (xorder === "7_3_14") {
      xtabtitle = "7.3-14 ร้อยละบุคลากรที่ได้รับจักสรรอัตรากำลัง ทุกกลุ่ม";

      header.push("", "2565", "", "2566", "", "2567", "", "2568", "");
      header2.push(
        "",
        "จำนวนที่ขอ : จำนวนที่ได้",
        "ร้อยละ",
        "จำนวนที่ขอ : จำนวนที่ได้",
        "ร้อยละ",
        "จำนวนที่ขอ : จำนวนที่ได้",
        "ร้อยละ",
        "จำนวนที่ขอ : จำนวนที่ได้",
        "ร้อยละ"
      );
    } else if (xorder === "7_3_15") {
      xtabtitle = "7.3-15 คะแนนประเมินขีดความสามารถของบุคลากรใหม่";
      header.push(
        "",
        "ปี 2564",
        "ปี 2565",
        "ปี 2566",
        "ปี 2567",
        "ปี 2568",
        "% ได้ต่อสัญญาใหม่"
      );
    } else if (xorder === "7_3_18") {
      xtabtitle = "7.3-18 จำนวนบุคลากรที่ลาออกก่อนหมดสัญญา";
      header.push("", "2568");
    } else if (xorder === "7_3_22") {
      xtabtitle = "7.3-22 การเตรียมหัวหน้างานและผู้บริหารในอนาคต";
      header.push("", "2564", "2565", "2566", "2567", "2568");
    }

    xdata.push([xtabtitle]);

    xdata.push([""]);
    xdata.push(header);
    if (header2.length > 0) {
      xdata.push(header2);
    }

    if (xorder === "7_3_5") {
      for (var row in dataEx7_3_5) {
        const xx = [];

        for (var col in dataEx7_3_5[row]) {
          xx.push(dataEx7_3_5[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_3_6") {
      for (var row in dataEx7_3_6) {
        const xx = [];

        for (var col in dataEx7_3_6[row]) {
          xx.push(dataEx7_3_6[row][col]);
        }

        xdata.push(xx);
      }

      xdata.push([""]);
      xdata.push([
        "หมายเหตุ: ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ (1 ต.ค. 67 - 30 ก.ย. 68)"
      ]);
    } else if (xorder === "7_3_8") {
      for (var row in dataEx7_3_8) {
        const xx = [];

        for (var col in dataEx7_3_8[row]) {
          xx.push(dataEx7_3_8[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_3_9") {
      for (var row in dataEx7_3_9) {
        const xx = [];

        for (var col in dataEx7_3_9[row]) {
          xx.push(dataEx7_3_9[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_3_10") {
      for (var row in data7_3_10) {
        const xx = [];
        for (var col in data7_3_10[row]) {
          xx.push(data7_3_10[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_12") {
      for (var row in dataEx7_3_12) {
        const xx = [];
        for (var col in dataEx7_3_12[row]) {
          xx.push(dataEx7_3_12[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_13") {
      for (var row in dataEx7_3_13) {
        const xx = [];
        for (var col in dataEx7_3_13[row]) {
          xx.push(dataEx7_3_13[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_14") {
      for (var row in dataEx7_3_14) {
        const xx = [];
        for (var col in dataEx7_3_14[row]) {
          xx.push(dataEx7_3_14[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_15") {
      for (var row in dataEx7_3_15) {
        const xx = [];
        for (var col in dataEx7_3_15[row]) {
          xx.push(dataEx7_3_15[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_18") {
      for (var row in dataEx7_3_18) {
        const xx = [];
        for (var col in dataEx7_3_18[row]) {
          xx.push(dataEx7_3_18[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_3_22") {
      for (var row in dataEx7_3_22) {
        const xx = [];
        for (var col in dataEx7_3_22[row]) {
          xx.push(dataEx7_3_22[row][col]);
        }
        xdata.push(xx);
      }
    }

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, xtabtitle + ".xlsx");
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านบุคลากร
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-1 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_1} order={"bar7_3_1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-2 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS Q1 ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_2} order={"bar7_3_2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-3 จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย"
          >
            {/* <Barchart dataBar={dataBar7_3_3} order={"bar7_3_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_3_จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย_SciV.xlsx",
                    "_blank"
                  )}
              >
                จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-4 ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_4_ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ.xlsx",
                    "_blank"
                  )}
              >
                ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-5 จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่ออาจารย์"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button ghost type="success" onClick={() => bExcelClick("7_3_5")}>
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_5}
              dataSource={data7_3_5}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-6 ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button ghost type="success" onClick={() => bExcelClick("7_3_6")}>
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_6}
              dataSource={data7_3_6}
              pagination={false}
              size="small"
              bordered
            />
            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ร้อยละอาจารย์ที่มีตำแหน่งวิชาการ (1 ต.ค. 67 - 30 ก.ย.
              68)
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-7 ผลประเมินการเรียนการสอนของอาจารย์"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiNTgwZmRiNjQtYzhjNi00ZjUyLWI1ZTctMzFiOGQ3Y2NkMDZjIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมิน อาจารย์
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-8 ผลการประเมินขีดความสามารถบุคลากรสายปฏิบัติการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button ghost type="success" onClick={() => bExcelClick("7_3_8")}>
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_8}
              dataSource={data7_3_8}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-9 ผลการประเมินการให้บริการและสนับสนุนสายวิชาการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button ghost type="success" onClick={() => bExcelClick("7_3_9")}>
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_9}
              dataSource={data7_3_9}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-10 สัดส่วนจำนวนโครงการและทุนวิจัยต่อนักวิจัย"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_10")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_10}
              dataSource={data7_3_10}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-11 ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_3/file_7_3_11ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย.xlsx",
                    "_blank"
                  )}
              >
                ข้อมูลจำนวนนักวิจัยและผลตีพิมพ์แยกตามทิศทางวิจัย
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-12 อัตราส่วนของ นศ. ต่อบุคลากรสายวิชาการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_12")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_12}
              dataSource={data7_3_12}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-13 จำนวนและอัตรส่วนของบุคลากรสายสับสนุน และสายวิชาการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_13")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_13}
              dataSource={data7_3_13}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-14 ร้อยละบุคลากรที่ได้รับจักสรรอัตรากำลัง ทุกกลุ่ม"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_14")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_14}
              dataSource={data7_3_14}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-15 คะแนนประเมินขีดความสามารถของบุคลากรใหม่"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_15")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_15}
              dataSource={data7_3_15}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-16 ผลประเมินความพึงพอใจของบุคลากร"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมินความพึงพอใจของบุคลากร
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 9 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-17 ผลลัพธ์ด้านความผูกพันของบุคลากรแต่ละกลุ่ม"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลลัพธ์ด้านความผูกพันของบุคลากรแต่ละกลุ่ม
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-18 จำนวนบุคลากรที่ลาออกก่อนหมดสัญญา"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_18")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_18}
              dataSource={data7_3_18}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 10 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-19 ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการสร้างความผูกพันธ์"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการสร้างความผูกพันธ์
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-20 ความไม่พึงพอใจของบุคลากรต่อการทำงานในสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ความไม่พึงพอใจของบุคลากรต่อการทำงานในสถาบันฯ
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 11 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-21 ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการพัฒนาบุคลากร"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ผลประเมินความพึงพอใจของบุคลากรต่อกระบวนการพัฒนาบุคลากร
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="7.3-22 การเตรียมหัวหน้างานและผู้บริหารในอนาคต"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_3_22")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_3_22}
              dataSource={data7_3_22}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_3;
